import React, { useEffect, useState } from 'react';
import '../assets/styles/notification.css';
import config from '../config.js';
import axios from "axios";

const NotificationModal = ({ closePopup }) => {
    const [notifyData, setNotifyData] = useState([]);
    useEffect(() => {
        axios
            .get(`${config.apiBaseUrl}/admin/requestlince`)
            .then((response) => {
                setNotifyData(response.data);
            })
            .catch((err) => {
                console.error('Error fetching data');
            });
    }, []);
    return (
        <div className="notifications-overlay">
            <div className="notifications-modal">
                <div>
                    <h5 className='head-notify-st'>Notification</h5>
                    <button onClick={closePopup} className="close-btn">&times;</button>
                </div>
                <ul className='ul-st'>
                    {notifyData.map((item, index) => (
                        <li key={index} className='list-notify-msg'>
                            <div className='d-flex '>
                                <div className="pe-3 d-flex justify-content-center align-items-center">
                                    <h4
                                        className={`noti-name ms-2 ${item.request_type.toLowerCase() === 'plan upgrade'
                                                ? 'noti-name1'
                                                : item.request_type.toLowerCase() === 'license upgrade'
                                                    ? 'noti-name2'
                                                    : ''
                                            }`}
                                    >
                                        {item.request_type.charAt(0)}
                                    </h4>
                                </div>
                                <div className='pe-2 d-flex flex-column align-items-start'>
                                    <div className='d-flex align-items-center '>
                                        <h6 className='m-0  '>
                                            {item.client_id ? item.client_name : item.franchise_name}
                                        </h6>
                                    </div>
                                    <p className='format-data-st m-0'>
                                        {new Date(item.created_date).toLocaleDateString('en-IN')}
                                    </p>
                                    <div className='d-flex align-items-center '>
                                        <h6 className='mt-2 requesttype'>
                                            {item.request_type}
                                        </h6>
                                    </div>
                                </div>
                                <div className='day-count-st d-flex justify-content-end align-items-center'>
                                    {item.created_date_relative}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default NotificationModal;